//@ts-check

import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar
  } from '@ionic/react';
import {  } from 'ionicons/icons';
import React from 'react';
import './TabVentilation.css';

interface IAppProps {};

const TabVentilation: React.FunctionComponent<IAppProps> = (props) => {
  return (
    <>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Tab Ventilation</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent />
    </>
  );
};

export default TabVentilation;
